import { useCurrentProfile } from '@map/state/profile';
import { windowExtended } from '@map/types';

type FeatureName =
  // these come from the profile in the redux store
  | 'courses'
  | 'learnSection'
  | 'careerInterestTest'
  | 'jobsSection'
  | 'vacancies'
  | 'saudiIllustrations'
  | 'webchat'
  | 'relatedLicensesAndCertificates'
  | 'relatedDegrees'
  | 'marketData'
  | 'jobReadinessTrainingSection'
  | 'onboarding'
  | 'sessionScheduling'
  | 'markAttendance'
  | 'npsRating'
  | 'csatRating'
  | 'sessionsRatings'
  | 'careerPlanDev'
  | 'courseLocation'
  | 'taskManagement'
  | 'theoryOfChange'
  | 'guardianSupervision'
  // these come from the project, i.e. from windowExtended.project.features
  | 'phoneNumberAuth'
  | 'careersInDemand'
  | 'emailAuth'
  | 'facebookSignin'
  | 'googleSignin'
  | 'visitorAccess'
  | 'managePosts'
  | 'supportPrograms'
  | 'isLite'
  | 'pageRatings'
  | 'mentorship'
  | 'ticketSubmissionCrm'
  | 'nefathSignin'
  | 'autoBeneficiaryAssignment'
  | 'roleModels'
  | 'enforceEmailConfirmation'
  | 'careerGroups';

export const updateProjectFeatures = (features: string[]) => {
  windowExtended.project.features = features;
};

const useFeatureIsAccessible = (featureName: FeatureName) => {
  const { accessible_features: features } = useCurrentProfile();
  return (
    features.includes(featureName) ||
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (windowExtended.project && windowExtended.project.features.includes(featureName))
  );
};

export default useFeatureIsAccessible;
